export function slugifyCategory(str) {
  return String(str || '')
    .toLowerCase()
    .trim()
    .replace(/['']/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-');
}

/** Title Case for storefront/admin labels — slugs stay lowercase via slugifyCategory. */
export function formatCatalogDisplayName(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.replace(/[A-Za-zÀ-ÿ]+(?:'[A-Za-zÀ-ÿ]+)?/g, (word) => {
    if (word.length <= 1) return word.toUpperCase();
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

/** Alphabetical order for storefront category nav, grid, and panels. */
export function sortCategoriesAlphabetically(categories = []) {
  return [...categories].sort((a, b) =>
    String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
  );
}

/**
 * Build nested menu tree from flat subcategory rows.
 * Top-level: parentSubCategory null. Groups: isGroup true. Leaves: isGroup false.
 */
export function buildCategoryMenuTree(flatSubs = []) {
  const byId = new Map();
  const roots = [];

  flatSubs.forEach((sub) => {
    const id = String(sub.id || sub._id || '');
    if (!id) return;
    byId.set(id, {
      id,
      name: formatCatalogDisplayName(sub.name),
      slug: sub.slug || slugifyCategory(sub.name),
      isGroup: sub.isGroup === true,
      displayOrder: sub.displayOrder ?? 0,
      parentSubCategory: sub.parentSubCategory ? String(sub.parentSubCategory) : null,
      children: [],
    });
  });

  byId.forEach((node) => {
    if (node.parentSubCategory && byId.has(node.parentSubCategory)) {
      byId.get(node.parentSubCategory).children.push(node);
    } else if (!node.parentSubCategory) {
      roots.push(node);
    }
  });

  const sortNodes = (list) => {
    list.sort((a, b) => (a.displayOrder - b.displayOrder) || a.name.localeCompare(b.name));
    list.forEach((n) => sortNodes(n.children));
  };
  sortNodes(roots);
  return roots;
}

/** Leaf subcategories only — for filters / sidebar. */
export function flattenLeafSubcategories(flatSubs = []) {
  return flatSubs
    .filter((s) => s.isGroup !== true)
    .map((sub) => ({
      id: sub.id || sub._id,
      railwayId: sub.railwayId || null,
      name: sub.name,
      slug: sub.slug || slugifyCategory(sub.name),
      displayOrder: sub.displayOrder ?? 0,
      parentSubCategory: sub.parentSubCategory || null,
    }))
    .sort((a, b) => (a.displayOrder - b.displayOrder) || a.name.localeCompare(b.name));
}

export function buildCategoryMenuTreeByCategory(flatSubsByCategory = {}) {
  const out = {};
  Object.entries(flatSubsByCategory).forEach(([catKey, subs]) => {
    out[catKey] = buildCategoryMenuTree(subs);
  });
  return out;
}
